<app-unauthorized-header-layout header="Two-Factor Authentication"
    subHeader="Set up your authenticator app"
    subHeader2="Scan the QR code with your authenticator app, then enter the 6-digit code it shows."></app-unauthorized-header-layout>
@if (errorMessage) {
<div class="flex p-error justify-content-center mt-4 mb-2 text-xl">{{errorMessage}}</div>
}
<div class="flex justify-content-center flex-wrap w-full mt-3">
    <div class="surface-card p-4 w-saraplus-form border-round w-full sm:w-7 md:w-5 lg:4">
        <div class="flex flex-column align-items-center">
            @if (otpAuthUri) {
            <qrcode [qrdata]="otpAuthUri" [width]="200" [errorCorrectionLevel]="'M'" [margin]="2"></qrcode>
            }
            @if (secret) {
            <p class="text-sm font-light text-color-secondary text-center mt-2 mb-4">
                Can't scan it? Enter this key manually:<br />
                <span class="font-medium">{{ secret }}</span>
            </p>
            }
            <sp-form-wrapper [formGroup]="codeForm" (submit)="onConfirm()" class="w-full">
                <div class="flex flex-column align-items-center">
                    <div class="mb-3">
                        <p-inputOtp [autofocus]="true" formControlName="code" [tabindex]="1" [integerOnly]="true"
                            [length]="6" class="w-full mb-1 justify-content-between"></p-inputOtp>
                        <sp-control-error [parameters]="['Code']" [control]="codeForm.controls['code']"></sp-control-error>
                    </div>
                    <div class="flex justify-content-between w-full mb-12rem">
                        <p-button icon="pi pi-chevron-left" label="Back" [link]="true"
                            styleClass="outline-none font-italic text-lg -ml-3" (click)="onBackClicked()"></p-button>
                        <button label="CONFIRM" pButton pRipple type="submit" [disabled]="!codeForm.valid" size="small">
                        </button>
                    </div>
                </div>
            </sp-form-wrapper>
        </div>
    </div>
</div>
